import React, { Component } from 'react';
import './Main.css';
import i01 from './images/01.jpg';
import i02 from './images/02.jpg';
import i03 from './images/03.jpg';
import i04 from './images/04.jpg';
import i05 from './images/05.jpg';


class Main extends Component {

  componentDidMount() {
    /*
      Eventually by HTML5 UP
      html5up.net | @ajlkn
      Free for personal and commercial use under the CCA 3.0 license (html5up.net/license)
    */

    (function() {
      // canUse
      window.canUse=function(p){if(!window._canUse)window._canUse=document.createElement('div');var e=window._canUse.style,up=p.charAt(0).toUpperCase()+p.slice(1);return p in e||'Moz'+up in e||'Webkit'+up in e||'O'+up in e||'ms'+up in e};

        // window.addEventListener
        (function(){if('addEventListener'in window)return;window.addEventListener=function(type,f){window.attachEvent('on'+type,f)}})();

        // Vars.
        var	$body = document.querySelector('body');

        // Disable animations/transitions until everything's loaded.
        $body.classList.add('is-loading');

        window.addEventListener('load', function() {
          window.setTimeout(function() {
            $body.classList.remove('is-loading');
          }, 100);
        });

        // Slideshow Background.
        (function() {

          // Settings.
            var settings = {

              // Images (in the format of 'url': 'alignment').
                images: {
                  [i01]: 'center',
                  [i02]: 'center',
                  [i03]: 'center',
                  [i04]: 'center',
                  [i05]: 'center'
                },

              // Delay.
                delay: 6000

            };

          // Vars.
            var	pos = 0, lastPos = 0,
              $wrapper, $bgs = [], $bg,
              k;

          // Create BG wrapper, BGs.
            $wrapper = document.createElement('div');
              $wrapper.id = 'bg';
              $body.appendChild($wrapper);

            for (k in settings.images) {

              // Create BG.
                $bg = document.createElement('div');
                  $bg.style.backgroundImage = 'url("' + k + '")';
                  $bg.style.backgroundPosition = settings.images[k];
                  $wrapper.appendChild($bg);

              // Add it to array.
                $bgs.push($bg);

            }

          // Main loop.
            $bgs[pos].classList.add('visible');
            $bgs[pos].classList.add('top');

            // Bail if we only have a single BG or the client doesn't support transitions.
              if ($bgs.length === 1
              ||	!window.canUse('transition'))
                return;

            window.setInterval(function() {

              lastPos = pos;
              pos++;

              // Wrap to beginning if necessary.
                if (pos >= $bgs.length)
                  pos = 0;

              // Swap top images.
                $bgs[lastPos].classList.remove('top');
                $bgs[pos].classList.add('visible');
                $bgs[pos].classList.add('top');

              // Hide last image after a short delay.
                window.setTimeout(function() {
                  $bgs[lastPos].classList.remove('visible');
                }, settings.delay / 2);

            }, settings.delay);

        })();

    })();
  }
  render() {
    return (
      <div id='main'></div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/Main.js